<template>
    <div class="row">
        <div class="col-sm-12">

            <a :href="url(`admin/employer/${employer_id}/driver-upload/new`)"
               class="pull-right btn btn-primary">Import</a>
            <h1 style="margin-bottom:10px">Hire Reports</h1>

            <div class="row">
                <div class="col-md-12 col-lg-12">
                    <h2 class="h5 h-aside is-toggable-mobile">
                        Filters
                    </h2>
                    <div class="flex">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label>From</label>
                                </div>
                            </div>
                            <el-date-picker
                                v-model="fromFilter"
                                format="M/d/yyyy"
                                clearable
                                value-format="yyyy-MM-dd"
                                type="date">
                            </el-date-picker>
                        </div>
                        <div class="form-group" style="margin-left:20px">
                            <div class="row">
                                <div class="col-sm-12">
                                    <label>To</label>
                                </div>
                            </div>
                            <el-date-picker
                                v-model="toFilter"
                                format="M/d/yyyy"
                                clearable
                                value-format="yyyy-MM-dd"
                                type="date">
                            </el-date-picker>
                        </div>
                        <div class="form-group" style="margin-left:20px;margin-top:25px;">
                            <div class="row">
                                <div class="col-sm-12">
                                    <el-button type="primary" @click="refresh">Apply Filter</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive" v-loading="loading">
                <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>Name</th>
                        <th>Employer's subaccounts</th>
                        <th>Total</th>
                        <th>Hires</th>
                        <th colspan="2"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="l in list">
                        <td>{{ l.date }}</td>
                        <td>{{ l.name }}</td>
                        <td>{{ l.employers }}</td>
                        <td>{{ l.drivers_total }}</td>
                        <td>{{ l.drivers_hired }}</td>
                        <td>
                            <a href="#" @click.prevent="download(l.id)">Download data</a>
                        </td>
                        <td>
                            <a href="#" @click.prevent="deleteRow(l.id)">Delete</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <validation-hire-download-dialog
            :show="show_dialogs.download"
            :driver_upload_id="show_dialogs.driver_upload_id"
            :employer_id="employer_id"
            @close="show_dialogs.download = false"
        ></validation-hire-download-dialog>

        <employer-notes-wrapper :employer-id="employer_id" />
    </div>
</template>

<script>
import ValidationHireDownloadDialog from "./validation-hire-download-dialog";

export default {
    components: {ValidationHireDownloadDialog},
    props: [
        'employer_id'
    ],
    data() {
        return {
            fromFilter: '',
            toFilter: '',
            list: [],
            show_dialogs: {
                download: false,
                driver_upload_id: null
            },
            loading: true
        };
    },
    methods: {
        deleteRow(id) {
            this.loading = true;
            return axios.post(url(`admin/employer/${this.employer_id}/hire-report/${id}/delete`))
                .then((response) => {
                    return this.refresh();
                });
        },
        download(id) {
            this.show_dialogs.download = true;
            this.show_dialogs.driver_upload_id = id;
        },
        refresh() {
            this.loading = true;
            return axios.get(url(encodeURI(`admin/employer/${this.employer_id}/hire-report/list/data?from=${this.fromFilter}&to=${this.toFilter}`)))
                .then((response) => {
                    this.list = response.data.list;
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>
